import services from '~api/visit';
import * as types from '../types';

export default {
  // 列表
  getVisitList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      services
        .apiGetVisitList(payload)
        .then((res) => {
          if (res.data) {
            commit(types.GET_VISIT_LIST, res.data);
          }
          resolve(res);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },

  // 详情
  getVisitDetail({ commit }, payload) {
    return services.apiGetVisitDetail(payload).then((res) => {
      if (res.data) {
        commit(types.GET_VISIT_DETAIL, res.data);
      }
    });
  },

  // 类别
  getVisitType({ commit }, payload) {
    return new Promise((resolve, reject) => {
      services
        .apiGetVisitType(payload)
        .then((res) => {
          if (res.data) {
            commit(types.GET_STATISTICS_VISIT_TYPE, res.data);
          }
          resolve(res);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  // 获取拜访团队
  getVisitTeams({ commit }, payload) {
    return services
      .apiGetVisitTeams(payload)
      .then((res) => {
        const data = res.data;
        commit(types.GET_VISIT_TEAMS, data);
      })
      .catch(() => {});
  },
  // 导出
  handleVisitExport({ commit }, payload) {
    return services.apiHandleVisitExport(payload.params, payload.config);
  },
  // 删除
  deleteHandleVisit({ commit }, payload) {
    return services.apiHandleDeleteVisit(payload);
  },

  // 新增
  addHandleVisit({ commit }, payload) {
    return services.apiHandleAddVisit(payload);
  },

  // 编辑
  updateHandleVisit({ commit }, payload) {
    return services.apiHandleUpdateVisit(payload);
  },
  // 图片上传
  visitUploadFile({ commit }, payload) {
    return services.apiVisitUploadFile(payload.params, payload.config);
  },
  // 图片删除
  deleteVisitUploadFile({ commit }, payload) {
    return services.apiDeleteVisitUploadFile(payload);
  },

  // 拜访- 客户
  getVisitCustomerDataList({ commit }, payload) {
    return services
      .apiGetVisitCustomerDataList(payload)
      .then((res) => {
        const data = res.data;
        commit(types.GET_VISIT_CUSTOMER_DATA_LIST, data);
      })
      .catch(() => {});
  },
  // 拜访- 医生客户
  getVisitMedicalCustomerDataList({ commit }, payload) {
    return services
      .apiGetVisitMedicalCustomerDataList(payload)
      .then((res) => {
        const data = res.data;
        commit(types.GET_VISIT_MEDICAL_CUSTOMER_DATA_LIST, data);
      })
      .catch(() => {});
  },

  // 拜访- 业务员
  getVisitCustomerSalesmanDataList({ commit }, payload) {
    return services
      .apiGetVisitCustomerSalesmanDataList(payload)
      .then((res) => {
        const data = res.data.data;
        commit(types.GET_VISIT_CUSTOMER_SALESMAN_DATA_LIST, data);
      })
      .catch(() => {});
  },

  // 拜访- 客户 - 联系人
  getVisitCustomerConvertDataList({ commit }, payload) {
    return services
      .apiGetVisitCustomerConvertDataList(payload)
      .then((res) => {
        const data = res.data;
        commit(types.GET_VISIT_CUSTOMER_CONVERT_DATA_LIST, data);
      })
      .catch(() => {});
  },

  // 拜访- 商机
  getVisitBusinessDataList({ commit }, payload) {
    return services
      .apiGetVisitBusinessDataList(payload)
      .then((res) => {
        const data = res.data;
        commit(types.GET_VISIT_BUSINESS_DATA_LIST, data);
      })
      .catch(() => {});
  },

  // 拜访- 商机 - 联系人
  getVisitBusinessConvertDataList({ commit }, payload) {
    return services
      .apiGetVisitBusinessConvertDataList(payload)
      .then((res) => {
        const data = res.data;
        commit(types.GET_VISIT_BUSINESS_CONVERT_DATA_LIST, data);
      })
      .catch(() => {});
  },

  // 拜访- 线索
  getVisitCluesDataList({ commit }, payload) {
    return services
      .apiGetVisitCluesDataList(payload)
      .then((res) => {
        const data = res.data;
        commit(types.GET_VISIT_CLUES_DATA_LIST, data);
      })
      .catch(() => {});
  },
};
